<template>
    <div class="mx-2 mx-md-4 mx-lg-0">
        <loading :active='isLoading'/>

        <h3 class="h3 mt-3 mb-4 bg-secondary p-2 rounded border">User Transcripts</h3>

        <div class="mt-1 mb-5 row">
            <div class="col-12 col-md-6 col-lg-4" v-for="trans in transactions">
                <div class="card mb-4" >
                    <div class="card-header">
                        <h5 class="card-title">{{ trans['_Event']['EventName'] }}</h5>
                        <h6 class="card-subtitle small text-muted">{{ trans['_Event']['FormattedDate'] }}</h6>
                    </div>
                    <div class="card-body">
                        <table class="table small">
                            <tr>
                                <td class="text-end" style="width:40%">Confirmation:</td>
                                <td class="fw-bold">{{ trans['ConfirmationNo'] ?? ''}}</td>
                            </tr>
                            <tr>
                                <td class="text-end">Paid:</td>
                                <td v-if="trans['PaidStatus']"><i class="far fa-check-circle text-success"></i></td>
                                <td v-else><i class="far fa-times-circle text-danger"></i></td>
                            </tr>
                            <tr>
                                <td class="text-end">Attended:</td>
                                <td v-if="trans['AttendanceStatus']"><i class="far fa-check-circle text-success"></i></td>
                                <td v-else><i class="far fa-times-circle text-danger"></i></td>
                            </tr>
                            <tr>
                                <td class="text-end">Payment type:</td>
                                <td v-if="trans['PaymentMethod'] == 'cc'" class="fw-bold">Credit Card</td>
                                <td v-else-if="trans['PaymentMethod'] == 'po'" class="fw-bold">Purchase Order</td>
                                <td v-else-if="trans['PaymentMethod'] == 'mo'" class="fw-bold">Money Order</td>
                                <td v-else-if="trans['PaymentMethod'] == 'aa' || trans['PaymentMethod'] == 'Agency Agreement'" class="fw-bold">Consortium</td>
                                <td v-else-if="trans['PaymentMethod'] == 'pc' || trans['PaymentMethod'] == 'Personal Check'" class="fw-bold">Personal Check</td>
                                <td v-else class="fw-bold">Unknown</td>
                            </tr>

                            <tr v-if="trans['GraduateCredit']">
                                <td class="text-end">Grad Credit:</td>
                                <td class="fw-bold">{{ trans['GraduateCredit'] }}</td>
                            </tr>
                            
                            <tr v-if="trans['_Event']['ContactHours']">
                                <td class="text-end">Contact Hours:</td>
                                <td class="fw-bold">{{ trans['_Event']['ContactHours'] }}</td>
                            </tr>
                        </table>
                    </div>
                    <div class="card-footer">
                        <small class="">
                            <a class="badge bg-primary" href="javascript:void(0)" @click="$router.push(`/event/${trans['EventID']}`)" >{{ trans['EventID'] }}</a>
                            <span v-if="trans['TransIssueRefund']" class="badge bg-danger">Refunded</span>
                            <a v-else-if="trans['_Event']['_Certificate']" class="badge bg-success" :href="`/certificate/${trans['EncryptedCertPath']}`"><i class="fas fa-certificate"></i>&nbsp;CERTIFICATE</a>
                        </small>
                    </div>
                </div>
            </div>

            <h5 v-if="!transactions">No events found</h5>
        </div>

    </div>
</template>

<script>
import axios from 'axios';
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';

export default {
    components: {
        Loading,
    },

    mounted() {
        this.isLoading = true;
        axios
            .get('/api/transcripts')
            .then(response => {
                console.debug(response.data.data);
                this.transactions = response.data.data;
            })
            .catch(error => {
                console.error(error);
                console.error(error.response);
            })
            .finally(() => {
                this.isLoading = false;
            });
    },

    methods: {
        loadCertificate: function() {
            // asset('/certificate/' . encrypt($trans['TransactionGUID']) )
            
        },
    },

    data() {
        return {
            isLoading: false,
            transactions: [],
        };
    },
}
</script>